import { toast } from "react-toastify"
import axiosInstance from "../../services/axios-client"
import { useState } from "react"

const useSidebar = () => {
    const [project, setProject] = useState()
    const [spmoProject, setSpmoProject] = useState()
    const LogoutFunction = async(e, logout) => {
        e.preventDefault()
        try {
            let res = await axiosInstance.post("/auth/logout")
            if (res.status===200){
                logout()
                toast.success("Successfullly logout")
            }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }       
    }
    
    const getAllProject = async(calibratorID) => {
        try {
            let res = await axiosInstance.get(`/auth/projects/calibrator?calibratorID=${calibratorID}`)
            if (res.status===200) {
                setProject(res.data.data)
            }
            
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }

    }

    const getAllProjectSpmo = async(spmoID) => {
        try {
            let res = await axiosInstance.get(`/auth/projects/spmo?spmoID=${spmoID}`)
            if (res.status===200) {
                setSpmoProject(res.data.data)
            }
            
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }

    }
    return{
        LogoutFunction,
        getAllProject,
        project,
        getAllProjectSpmo,
        spmoProject
    }
}

export default useSidebar